var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_box - material") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filtre2",
    transform: "translate(-478.000000, -95.000000)",
    fill: "#00122C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(469.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.736,54.039 L23.611,46.164 L22.372,44.883 L15.736,51.54 L12.628,48.411 L11.389,49.65 L15.736,54.039 Z M23.611,41.775 C24.1010025,41.775 24.5174983,41.9499982 24.8605,42.3 C25.2035017,42.6500018 25.375,43.0629976 25.375,43.539 L25.375,55.761 C25.375,56.2370024 25.2035017,56.6499982 24.8605,57 C24.5174983,57.3500018 24.1010025,57.525 23.611,57.525 L11.389,57.525 C10.8989976,57.525 10.4825017,57.3500018 10.1395,57 C9.79649829,56.6499982 9.625,56.2370024 9.625,55.761 L9.625,43.539 C9.625,43.0629976 9.79649829,42.6500018 10.1395,42.3 C10.4825017,41.9499982 10.8989976,41.775 11.389,41.775 L23.611,41.775 Z",
    id: "check_box---material"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.d4b7a897e73f590703e5334f90faf6b5.svg";
export { ForwardRef as ReactComponent };